<template>
  <SearchX class="w-16 h-16 mx-auto mb-4 text-gray-400" />
</template>

<script setup lang="ts">
import { defineOptions } from 'vue'
import { SearchX } from 'lucide-vue-next'

defineOptions({
  inheritAttrs: false
})
</script>
